import React from 'react';
import Logo from 'assets/images/graas_blue.svg';
import { compact as _compact } from 'lodash-es';
import './Footer.scss';

const Footer = () => {
  return (
    <footer className={`c-footer ${_compact(window.location.pathname?.split('/'))?.[0] || ''}`}>
      <span className='footer_text'>Powered by</span>
      <img src={Logo} alt='graas' className='footer_img' height='34' width='102' />
    </footer>
  );
};

export default Footer;
